// extracted by mini-css-extract-plugin
export default {"modalClient":"EditContactModal_modalClient__tfCMO","modalName":"EditContactModal_modalName__4peHU","dateInput":"EditContactModal_dateInput__p-0fz"};